const PAYMENT_ERRORS = {
  REASON: {
    CANCEL: 'general.errors.payment.cancel',
    FAIL: 'general.errors.payment.fail',
    TIMEOUT: 'general.errors.payment.timeout',
  },
};

export default PAYMENT_ERRORS;
